import { createApiAction } from './common'

export const getTreadmillConfiguration = createApiAction('getTreadmillConfiguration')
export const updateTreadmillConfiguration = createApiAction('updateTreadmillConfiguration',
  (denominator, numerator, maxPoint, maxTime, maxDistance) => ({ denominator, numerator, maxPoint, maxTime, maxDistance }))
